import { render, staticRenderFns } from "./OnboardingTimer.vue?vue&type=template&id=b22fa954"
import script from "./OnboardingTimer.vue?vue&type=script&lang=js"
export * from "./OnboardingTimer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports